
import { Component, Vue } from "vue-property-decorator";
import { WechatService,  UserService, OrderService, EmployerActivityService } from "src/services";
import { Toast, Dialog } from "vant";
import dayjs from "dayjs";
import { tools, Pay } from "src/utils";
import UAuthorization from "../authorization.vue";

Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate" // for vue-router 2.2+
]);

@Component({
    components:
    {
        UAuthorization,
    }
})
export default class SubmitOrder extends Vue
{
    /**
     * 是否完善信息
     * @private
     * @returns boolean
     */
    private isPerfect: boolean = true;

    /**
     * 选择人员
     * @protected
     * @returns boolean
     */
     protected showUserPopup: boolean = false;

     /**
     * 是否同意协议
     * @private
     * @returns boolean
     */
     private checkedAgreement: boolean = true;
    
    /**
     * 是否选择日期
     * @private
     * @returns boolean
     */
    private showDate: boolean = false;

    /**
     * 显示确认弹框
     * @private
     * @returns boolean
     */
    private showDialog: boolean = false;

    /**
     * 固定项目展开id集合
     * @private
     * @returns Array<number>
     */
    private fixedCollapseActive: Array<number> = [];

    /**
     * 加项项目展开id集合
     * @private
     * @returns Array<number>
     */
    private collapseActiveNames: Array<number> = [];

    /**
     * 机构相关信息
     * @private
     * @returns any
     */
    private hospitalInfo: any =
    {
        address: "",
        hospitalId: null,
        hospitalName: null,
        latitude: null,
        longitude: null,
    };

    /**
     * 用户相关信息
     * @private
     * @returns any
     */
    private memberInfo: any =
    {
        cardNo: null,
        cardType: null,
        cardTypeStr: null,
        employerMemberId: null,
        memberId: null,
        memberName: null,
        phone: null
    };

    /**
     * 套餐信息
     * @private
     * @returns any
     */
    private packageInfo: any =
    {
        baseItemTypes: [],
        basePrice: null,
        couponUsingAmount: null,
        needPayAmount: null,
        optionalItemTypes: [],
        optionalPrice: null,
        packageId: null,
        packageName: null,
        walletUsingAmount: null
    };

    /**
     * 是否在加载中
     * @private
     * @returns boolean
     */
    private loading: boolean = false;

    /**
     * 选择日期
     * @private
     * @returns any
     */
    private selectOrderDate: string = '';

    /**
     * 选择日期时间段
     * @private
     * @returns string
     */
    private physicalTimePeriod: string = '';

    /**
     * 取消授权报告弹框
     * @private
     * @returns boolean
     */
     private showOverlay: boolean = false;

    /**
     * 是否显示用户授权协议
     * @private
     * @returns boolean
     */
    public showAuthorization: boolean = false;
    
    /**
     * 选中加项id
     * @private
     * @returns any
     */
     private get onlyBuyOptionalItem(): any
    {
        let selectIds = [];
        // 健康产品id
        let healthProductIds = [];
        // 普通加项id
        let optionalItemIds = [];
        this.packageInfo.optionalItemTypes.forEach(item => {
            if (item.items && item.items.length > 0) {
                item.items.forEach(each => {
                    selectIds.push(each.itemId);
                    // 健康产品
                    if(each.itemTypeKind == 3)
                    {
                        healthProductIds.push(each.itemId);
                    }
                    // 普通加项
                    else
                    {
                        optionalItemIds.push(each.itemId);
                    }
                    
                })
            }
        });
        return { selectIds, healthProductIds, optionalItemIds };
    }

    /**
     * 订单类型
     * @private
     * @returns string
     */
    //  private get showOrderInfo(): boolean
    // {
    //     if(this.packageInfo.optionalPrice >= 0 || (this.selectUserId == this.userInfo.userId && this.packageInfo.couponUsingAmount >= 0) || this.packageInfo.needPayAmount >= 0) {
    //         return true;
    //     }
    //     return false;
    // }

    /**
     * 订单类型
     * @private
     * @returns string
     */
    private get orderKind(): string
    {
        return this.$route.query && (this.$route.query.orderKind as string) || "";
    }
    
    /**
     * 订单编号
     * @private
     * @returns string
     */
     private get orderId(): string
    {
        return this.$route.query && (this.$route.query.orderId as string) || "";
    }

    /**
     * 机构信息
     * @private
     * @returns object
     */
    private get hospitalId(): any
    {
        return this.$route.query && (this.$route.query.hospitalId as any) || null;
    }

    /**
     * 主题配置
     * @private
     * @returns any
     */
    private get properties(): any
    {
        return this.$store.state.properties || {};
    }
    
    /**
     * 是否取消授权
     * @private
     * @returns void
     */
     private agreementChange() {
        if(!this.checkedAgreement) {
            this.checkedAgreement = true
            this.showOverlay = true
        }
    }

    /**
     * 取消授权
     * @private
     * @returns boolean
     */
     private laterView() {
        this.showOverlay= false
        this.checkedAgreement = false
    }

    /* 关闭用户授权协议
    * @private
    * @returns void
    */
    private closeAuthorization() {
        this.showAuthorization = false
    }

    /* 判断是oppo或health
    * @private
    * @returns void
    */
    private onAgreement() {
        this.onAuthorization()
    }

    /**
     * 再想想
     */
     protected onAgree(): any {
        this.showOverlay = false;
        this.checkedAgreement = true
    }

     /**
     * 用户授权协议
     * @private
     * @returns void
     */
     private onAuthorization(): void {
        this.showAuthorization = true;
    }
    
    /**
     * 获取固定套餐项目个数
     * @private
     * 
     * @returns number
     */
    private get fixedNum(): number
    {
        let sum = 0;

        this.packageInfo && this.packageInfo.baseItemTypes.forEach((item)=>
        {
            sum += item.items && item.items.length || 0
            
        })

        return sum;
    }

    /**
     * 获取当前登入信息
     * @private
     * @returns void
     */
    private get selectUserId(): any
    {
        let selectUserStorage = localStorage.getItem("selectUser");
        
        if(selectUserStorage)
        {
            return JSON.parse(selectUserStorage).employerMemberId || this.userInfo.userId;
        }

        return this.userInfo.userId;
    }

    /**
     * 获取当前登入信息
     * @private
     * @returns void
     */
    private get userInfo(): any
    {
        return this.$store.getters.userInfo || {};
    }

    /**
     * 页面是否回退-h5环境
     * @private
     * @returns boolean
     */
    private get goback(): boolean
    {
        if(this.$route.query && this.$route.query.goback)
        {
           return true;
        }

        return false;
    }

    /**
     * 确认切换用户
     * @private
     * @returns void
     */
    protected onConfirmUser(data: any): void
    {
        this.memberInfo.cardNo = data.cardNo;
        this.memberInfo.cardType = data.cardType;
        this.memberInfo.cardTypeStr = "";
        this.memberInfo.employerMemberId = data.employerMemberId;
        this.memberInfo.memberName = data.memberName;
        this.memberInfo.phone = data.phone;
        this.getCheckIsPerfect(data.memberId);
        this.showUserPopup = false;
    }

    /**
     * 组件创建钩子
     * @private
     * @returns void
     */
    private created(): void
    {

        if(!localStorage.getItem("userInfo"))
        {
            this.$router.replace({name:"login", query:{redirect: location.href}});
            return;
        }
        this.pendingGetPreInfo();
        this.getCheckIsPerfect();
    }


    /**
     * 套餐id
     * @private
     * @returns string
     */
    private get date(): string
    {
        let date = "";
        if(this.$route.query && this.$route.query.date)
        {
            date = this.$route.query.date as string;
        }
        return date;
    }

    /**
     * 获取套餐详情
     * @private
     * @returns void
     */
    private async pendingGetPreInfo(): Promise<void>
    {
        try
        {
            let {content: result} =  await OrderService.instance.pendingGetPreInfo(this.orderId);

            if(result.data)
            {
                this.packageInfo = result.data.packageInfo;
                this.memberInfo = result.data.memberInfo;
                if (this.hospitalId) {
                    let {content: res} =  await OrderService.instance.getHospitalInfo(this.hospitalId);
                    this.hospitalInfo = res.data;
                }
                else {
                    this.hospitalInfo = result.data.hospitalInfo;
                }
            }

        }
        catch(err)
        {
            Toast(err);
        }
    }

    /**
     * 提交订单
     * @private
     * @returns void
     */
    private onSubmit()
    {
        if (!this.isPerfect)
        {
            Dialog.confirm({
                message: '您的个人信息未完善，是否前去完善',
                confirmButtonText: "立即完善",
                cancelButtonText: "稍后完善"
            })
            .then(() => {
                this.goToUser();
            })
            .catch(() => {
            });
            return;
        }
        if(!this.selectOrderDate)
        {
            Toast("请选择日期");
            return;
        }
        else
        {
            this.showDialog = true;
        }
    }

    /**
     * 跳转地图
     * @private
     * @returns void
     */
    private async openMap(hospitalOut: any): Promise<any>
    {
        if(hospitalOut)
        {
            let lat = hospitalOut.latitude;
            let lng =hospitalOut.longitude;;
            let address = hospitalOut.address;
            let orgName = hospitalOut.hospitalName;

            if(tools.isWechat())
            {
                let currentUrl = location.href;
                let {content: result} = await WechatService.instance.getWechatJSSDK(currentUrl);
                if(result.data)
                {
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: result.data.appId, // 必填，公众号的唯一标识
                        timestamp: result.data.timestamp, // 必填，生成签名的时间戳
                        nonceStr: result.data.nonceStr, // 必填，生成签名的随机串
                        signature: result.data.signature, // 必填，签名
                        jsApiList: ["openLocation"] // 必填，需要使用的JS接口列表
                    });

                    wx.ready(function()
                    {
                        wx.openLocation({
                            latitude: parseFloat(lat), // 纬度，范围为-90~90，负数表示南纬
                            longitude: parseFloat(lng), // 经度，范围为-180~180，负数表示西经
                            scale: 14, // 缩放比例
                            name: orgName,
                            address: address, // 地图缩放级别,整形值,范围从1~28。默认为最大
                            infoUrl: ""
                        });
                    });
                }
            }
            else
            {
                // 腾讯地图
                // let href = `http://apis.map.qq.com/uri/v1/marker?marker=coord:${lat},${lng};addr:${this.orgDetailInfo.org_name}`;
                // 高德
                let href = `http://uri.amap.com/marker?position=${lng},${lat}&name=${orgName}&coordinate=gaode&callnative=1`;
                window.open(href);
            }

        }

    }

    /**
     * 日期确认选择
     * @private
     * @returns string
     */
    private onDateConfirm(date: any, period: any): void
    {
        if(date)
        {
            this.selectOrderDate = dayjs(date).format("YYYY/MM/DD");
            this.physicalTimePeriod = period;
        }

        this.showDate = false;
    }

    /**
     * 提交订单
     * @private
     * @returns string
     */
    private async onConfirmSubmitOrder(): Promise<any>
    {
        try
        {
            if(this.loading)
            {
                return false;
            }
            this.loading = true;

            let data =
            {
                id: this.orderId,
                employerMemberId: this.memberInfo.employerMemberId, // 客户编号
                hospitalId: this.hospitalInfo.hospitalId, // 医院编号，外键
                physicalTime: this.selectOrderDate,
                physicalTimePeriod: this.physicalTimePeriod,
                agreeLicense:this.checkedAgreement,
            };

            let {content: result} = await OrderService.instance.pendingAppointment(data);
            localStorage.removeItem("selectOptionalItem");
            this.$router.push({name: "order-detail-unsubscribe", params:{id: this.orderId}});

        }
        catch(err)
        {
            Toast(err);
        }
        finally
        {
            this.loading = false;
        }
    }

    /**
     * 跳转成功页面
     * @private
     * @returns void
     */
    private onSucessDetail(id: string,hasHealthProduct: boolean): void
    {
        this.$router.push({name: "orderMiddle", query:{id: id,hasHealthProduct: hasHealthProduct+"" }});
    }

    /**
     * 跳转订单明细
     * @private
     * @returns void
     */
    private onActionOrderDetail(id: string): void
    {
        this.$router.push({name: "orderDetail", params:{id: id}});
    }

    /**
     * 显示排期弹框
     * @private
     * @returns void
     */
    private showDateModal(): void
    {
        this.showDate = true;
    }

    /**
     * 组件进来之前
     * @private
     * @returns void
     */
    private beforeRouteEnter(to, from, next): void
    {
        let appid = localStorage.getItem("appid");
        if (!tools.isAndroid() && `/${appid}${to.path}` !== location.pathname)
        {
           location.assign(`/${appid}${to.fullPath}`);
        }
        else
        {
            next();
        }
    }

    /**
     * 显示提示
     * @private
     * @returns void
     */
    private showTip(remark: string): void
    {
        Dialog.alert({
            messageAlign: "left",
            confirmButtonColor: "#00d5c1",
            message: remark,
            confirmButtonText: "确定"
        });
    }

    /**
     * 查询个人信息是否完善
     * @private
     * @returns void
     */
    private async getCheckIsPerfect(id?): Promise<void>
    {
        try
        {
            let params = {
                userId: id || this.memberInfo.employerMemberId
            }

            let {content: result} = await UserService.instance.checkIsPerfect(params);
            if (result.data)
            {
                this.isPerfect = result.data.isPerfect;
            }
        }
        catch(err)
        {
            Toast(JSON.stringify(err));
        }
    }

    /**
     * 跳转用户信息填写页面
     * @private
     * @returns void
     */
    private goToUser(): void {
        if (this.isPerfect)
        {
            return;
        }
        let query = Object.assign({userId: this.memberInfo.employerMemberId}, this.$route.query);
        this.$router.push({name: "family-operation", query: query});
    }
    
    /**
     * 切换机构
     * @private
     * @returns void
     */
     private onChangeOrg(): void
    {
        
        let query: any = { packageId: this.packageInfo.packageId, orderId: this.orderId, orderStatus: 'order-wait-submit', orderKind: this.orderKind };
        // 选中加项
        let params: any = {optionalItemIds: JSON.stringify(this.onlyBuyOptionalItem.selectIds)};
        this.$router.push({ name: "orgList", query, params });
    }
}
